import { format as DateFormatter } from 'date-fns';

export const getFormattedDate = (date: string, format: string) => {
  if (!date) return null;

  const [year, month, day] = date.substring(0, 10).split('-');

  return DateFormatter(new Date(Number(year), Number(month) - 1, Number(day)), format);
};
